<template>
  <div>
    <ca-row vertical-offset="2">
      <ca-col>
        <ca-heading text="Dados básicos" size="medium"></ca-heading>
      </ca-col>
    </ca-row>

    <ca-row-divider margin-bottom="medium"></ca-row-divider>

    <ca-row vertical-offset="3">
      <ca-col>
        <ca-field label="Nome">
          {{ basicInfo.name }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="4">
        <ca-field label="Matrícula do eSocial">
          {{ basicInfo.registration }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Email">
          {{ basicInfo.email }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Lotação">
          {{ basicInfo.allocation.description }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="4">
        <ca-field label="Função">
          {{ basicInfo.jobDescription.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Sindicato">
          {{ unionDescription }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Situação no eSocial">
          {{ basicInfo.esocialStatus.description }}
        </ca-field>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>

export default {
  name: 'WorkerBasicInfo',
  props: {
    basicInfo: Object,
  },
  computed: {
    unionDescription() {
      return this.basicInfo.union?.description || 'Sem sindicato';
    },
  },
};
</script>
